import moment from 'moment';
import { UpdateReferenceTypes, } from '@debbie/common/dist/updates';
import { collectionEngineV1 } from '../apis';
const updatesAPIV1 = collectionEngineV1('/updates', true);
export const types = () => updatesAPIV1('GET', `/types`);
export const getTodos = (updateTypeId, caseFilter, creditorId, responsibles, includeUnassigned) => updatesAPIV1('POST', `/todos/${updateTypeId}${creditorId ? `?creditorId=${creditorId}` : ''}`, {
    body: { caseFilter, responsibles, includeUnassigned },
});
export const createType = (newUpdate) => updatesAPIV1('POST', `/types`, {
    body: newUpdate,
});
export const delType = (updateTypeId) => updatesAPIV1('DELETE', `/types/${updateTypeId}`);
export const patchType = (updateTypeId, c) => updatesAPIV1('PATCH', `/types/${updateTypeId}`, { body: c });
export const getGroups = () => updatesAPIV1('GET', `/types/groups`);
export const getByReferenceId = (referenceId, casualConsistency) => updatesAPIV1('GET', `/${UpdateReferenceTypes.CASE}/${referenceId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const deleteUpdate = (updateId) => updatesAPIV1('DELETE', `/${updateId}`);
export const make = (update) => updatesAPIV1('POST', `/`, {
    body: update,
});
export const addTimeTrackingEntry = (updateId, from, to) => updatesAPIV1('POST', `/${updateId}/time-tracking`, {
    body: {
        from,
        to,
    },
});
export const patch = (updateId, patch) => updatesAPIV1('PATCH', `/${updateId}`, {
    body: Object.assign({ continuedAt: Object.keys(patch || {}).length === 0 ? moment().format() : undefined }, patch),
});
export const synchronizeResponsibles = () => updatesAPIV1('POST', '/synchronize-responsibles');
//# sourceMappingURL=updates.js.map